
import * as THREE from "three";
import {setupFlappyBird} from "../bird/flappybirdgame";
import {createCircleTexture} from "../three/canvastexture";
export { panels, materials }

//MATERIALS
let materials = {
    panelsBorder: new THREE.MeshLambertMaterial({
        color: 0x5683a6,
        transparent: true,
        opacity: 0
    }),
    panelsFull: new THREE.MeshLambertMaterial({
        color: 0x5683a6,
        transparent: true,
        opacity: 0
    }),
    title: new THREE.MeshLambertMaterial({
        color: 0xd8f4ff,
        transparent: true,
        opacity: 0
    }),
    items: new THREE.MeshLambertMaterial({
        color: 0x69a49f,
        transparent: true,
        opacity: 0
    }),
    materialItemTitle: new THREE.MeshLambertMaterial({
        color: 0xd8f4ff,
        transparent: true,
        opacity: 0
    }),
    materialBorder: new THREE.MeshLambertMaterial({
        color: 0xf0ca0c,
        transparent: true,
        opacity: 0
    }),
    screen: new THREE.MeshLambertMaterial({
        color: 0xd66f1c,
        transparent: true,
        opacity: 0
    }),
    overlayMaterial: new THREE.MeshLambertMaterial({
        color: 0xe72a50,
        transparent: true,
        opacity: 0
    })
}

let panels = {
    opacity: 1,
    borderWidth: 50,
    borderPadding: 20,
    borderMargin: 5,
    borderRotation: 1.58,

    itemTitleMargin: 90,
    itemTitleTopPadding: 40
};

